import axios from "axios";
import { getToken } from "./storage";

// Get IP address from environment variable
const serverIp = process.env.REACT_APP_API_BASE_URL;

if (!serverIp) {
  throw new Error(
    "REACT_APP_API_BASE_URL is not defined in your environment variables",
  );
}

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: `${serverIp}/api/v1`,
  timeout: 30000, // 30 seconds in milliseconds
});

// Interceptor to attach token when required
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    const requiresAuth = config.headers?.requiresAuth !== false;

    if (token && requiresAuth) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Remove the custom property before sending the request
    delete config.headers.requiresAuth;

    return config;
  },
  (error) => Promise.reject(error),
);

// Optional: You can intercept the response to handle the timeout error globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // If the request took longer than 30 seconds
    if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
      console.error("Request timed out after 30 seconds");
      // You could trigger a toast/notification here if you want
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
